import React from "react";
import "./About.css";
import { motion } from "framer-motion";
import teamImage from "../../assets/img7.png";

export default function About() {
  return (
    <section className="aboutPro" id="about" aria-label="About Alubomulla Hardware">
      <div className="aboutPro__bg" aria-hidden="true" />

      <div className="container aboutPro__wrap">
        {/* Left */}
        <motion.div
          className="aboutPro__left"
          initial={{ y: 18, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <p className="aboutPro__kicker">About Us</p>

          <h2 className="aboutPro__title">
            About <span>Alubomulla Hardware</span>
          </h2>

          <p className="aboutPro__sub">
            Serving Panadura and beyond with trusted tools, paint, plumbing, and building
            materials. Our focus is simple {" "}
            <b>reliable products, fair pricing, and friendly service</b> for every project.
          </p>

          <div className="aboutPro__badges">
            <span className="aboutPro__badge">Trusted Store</span>
            <span className="aboutPro__badge">Quality Brands</span>
            <span className="aboutPro__badge">Fast Delivery</span>
          </div>

          <div className="aboutPro__stats" role="list">
            <div className="aboutPro__stat" role="listitem">
              <div className="aboutPro__num">10,000+</div>
              <div className="aboutPro__lbl">Products in stock</div>
            </div>
            <div className="aboutPro__stat" role="listitem">
              <div className="aboutPro__num">Same-day</div>
              <div className="aboutPro__lbl">Delivery (city limits)</div>
            </div>
            <div className="aboutPro__stat" role="listitem">
              <div className="aboutPro__num">20,000+</div>
              <div className="aboutPro__lbl">Happy customers</div>
            </div>
            <div className="aboutPro__stat" role="listitem">
              <div className="aboutPro__num">4.8★</div>
              <div className="aboutPro__lbl">Service & quality</div>
            </div>
          </div>

          <div className="aboutPro__ctaRow">
            <a className="aboutPro__btn aboutPro__btnPrimary" href="#contact">
              Contact Us
            </a>
            <a className="aboutPro__btn aboutPro__btnGhost" href="#services">
              View Services
            </a>
          </div>
        </motion.div>

        {/* Right */}
        <motion.div
          className="aboutPro__right"
          initial={{ y: 18, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.7, ease: "easeOut", delay: 0.05 }}
        >
          <div className="aboutPro__media">
            <img src={teamImage} alt="Alubomulla Hardware" className="aboutPro__img" />
            <div className="aboutPro__glow" aria-hidden="true" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
